<div class="modal-header">
  <h4 class="modal-title synchpc-primary" id="modal-title">Update Gateway</h4>
  <i style="z-index: 1"
     class="bi bi-x-lg text-danger"
     color="warn"
     (click)="onClose()"
     title="Close"></i>
</div>
<div>
  <div class="modal-body text-grey">
    <form name="editGatewayForm"
        [formGroup]="editGatewayForm"
        (ngSubmit)="onSubmit(editGatewayForm)"
        autocomplete="off"
        spellcheck="false">
    <mat-form-field style="margin-top:5px; width: 95%">
      <mat-label>Gateway Name</mat-label>
      <input matInput style="font-size: 0.875em;"
             maxlength="20"
             placeholder="Gateway Name"
             formControlName="editGatewayName"
             title="Gateway name can be of maximum 20 characters containing alphabets, numbers, _ -" />
      <mat-error *ngIf="
          editGatewayForm.get('editGatewayName').touched &&
          editGatewayForm.get('editGatewayName').errors?.required
        ">Required</mat-error>
      <mat-error *ngIf="editGatewayForm.get('editGatewayName').errors?.pattern">Enter valid gateway name.</mat-error>
    </mat-form-field>

    <mat-form-field style="width: 95%">
      <mat-label>Gateway IP</mat-label>
      <input matInput style="font-size: 0.875em;"
             maxlength="15"
             placeholder="Gateway IP"
             formControlName="editGatewayIP" />
      <mat-error *ngIf="
          editGatewayForm.get('editGatewayIP').touched &&
          editGatewayForm.get('editGatewayIP').errors?.required
        ">Required</mat-error>
      <mat-error *ngIf="
          editGatewayForm.get('editGatewayIP').touched &&
          editGatewayForm.get('editGatewayIP').errors?.pattern
        ">Enter Valid IP</mat-error>
    </mat-form-field>

    <mat-form-field style="width: 95%">
      <mat-label>Gateway Port</mat-label>
      <input matInput style="font-size: 0.875em;"
             placeholder="Gateway Port"
             formControlName="editGatewayPort" />
      <mat-error *ngIf="
          editGatewayForm.get('editGatewayPort').touched &&
          editGatewayForm.get('editGatewayPort').errors?.required
        ">Required</mat-error>
      <mat-error *ngIf="
          editGatewayForm.get('editGatewayPort').touched &&
          editGatewayForm.get('editGatewayPort').errors?.pattern
        ">Enter Valid Port</mat-error>
    </mat-form-field>

    <div class="modal-footer">
      <button type="button"
              class="btn btn-outline-secondary"
              (click)="onClose()">
        Close
      </button>
      <button type="submit"
              class="btn btn-primary"
              [disabled]="!editGatewayForm.valid"
              [title]="!editGatewayForm.valid ? 'Submit button will be enabled when all required fields are filled' : 'New gateway will be edited on submitting the form.'">
        Submit
      </button>
    </div>
  </form>
  </div>
</div>
